module.exports = __webpack_public_path__ + "img/icon_dean_home_alert_icon_14.f2ce1063.png";